import script from "./SubhireWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./SubhireWidget.vue?vue&type=script&setup=true&lang=js"

import "./SubhireWidget.vue?vue&type=style&index=0&id=f799ef20&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f799ef20"]])

export default __exports__